import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

/* ── fake podcast background ──────────────────────────────────────── */
function PodcastBg() {
  return (
    <div style={{ position: 'absolute', inset: 0, overflow: 'hidden', background: '#0D2137' }}>
      {/* hero band */}
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 340, background: 'linear-gradient(135deg,#0D2137 60%,#1B6B72)' }}>
        <div style={{ position: 'absolute', top: 60, left: 80, width: 320, height: 18, background: 'rgba(255,255,255,.06)', borderRadius: 4 }} />
        <div style={{ position: 'absolute', top: 96, left: 80, width: 480, height: 52, background: 'rgba(255,255,255,.09)', borderRadius: 6 }} />
        <div style={{ position: 'absolute', top: 164, left: 80, width: 380, height: 16, background: 'rgba(255,255,255,.06)', borderRadius: 4 }} />
        <div style={{ position: 'absolute', top: 196, left: 80, width: 300, height: 16, background: 'rgba(255,255,255,.04)', borderRadius: 4 }} />
        <div style={{ position: 'absolute', top: 240, left: 80, display: 'flex', gap: 12 }}>
          {[140, 120, 160].map((w, i) => (
            <div key={i} style={{ width: w, height: 40, background: i === 0 ? 'rgba(27,107,114,.5)' : 'rgba(255,255,255,.07)', borderRadius: 8 }} />
          ))}
        </div>
        {/* mic circle */}
        <div style={{ position: 'absolute', top: 40, right: 120, width: 200, height: 200, borderRadius: '50%', background: 'rgba(201,168,76,.08)', border: '1.5px solid rgba(201,168,76,.15)' }}>
          <div style={{ position: 'absolute', inset: 20, borderRadius: '50%', background: 'rgba(201,168,76,.05)', border: '1px solid rgba(201,168,76,.10)' }}>
            <div style={{ position: 'absolute', inset: '50%', transform: 'translate(-50%,-50%)', width: 40, height: 40, borderRadius: '50%', background: 'rgba(201,168,76,.25)' }} />
          </div>
        </div>
      </div>
      {/* episode rows */}
      <div style={{ position: 'absolute', top: 360, left: 0, right: 0, padding: '0 80px' }}>
        {[0,1,2,3,4,5].map(i => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 20, marginBottom: 20, padding: '18px 24px', background: 'rgba(255,255,255,.04)', borderRadius: 10, border: '1px solid rgba(255,255,255,.06)' }}>
            <div style={{ width: 52, height: 52, borderRadius: 10, background: `hsl(${180 + i * 20},40%,${25 + i * 3}%)`, flexShrink: 0 }} />
            <div style={{ flex: 1 }}>
              <div style={{ width: `${55 + (i * 7) % 30}%`, height: 13, background: 'rgba(255,255,255,.12)', borderRadius: 3, marginBottom: 8 }} />
              <div style={{ width: `${40 + (i * 11) % 35}%`, height: 11, background: 'rgba(255,255,255,.07)', borderRadius: 3 }} />
            </div>
            <div style={{ width: 60, height: 28, background: 'rgba(27,107,114,.3)', borderRadius: 20 }} />
          </div>
        ))}
      </div>
      {/* right sidebar hint */}
      <div style={{ position: 'absolute', top: 360, right: 80, width: 220 }}>
        {[0,1,2].map(i => (
          <div key={i} style={{ marginBottom: 14, padding: '14px 16px', background: 'rgba(255,255,255,.03)', borderRadius: 8, border: '1px solid rgba(255,255,255,.05)' }}>
            <div style={{ width: '70%', height: 10, background: 'rgba(255,255,255,.1)', borderRadius: 3, marginBottom: 6 }} />
            <div style={{ width: '50%', height: 9, background: 'rgba(255,255,255,.06)', borderRadius: 3 }} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default function RoundTablePage() {
  const navigate = useNavigate();

  return (
    <div style={{ position: 'fixed', top: '70px', bottom: 0, left: 0, right: 0, zIndex: 0 }}>
      {/* ── blurred podcast background ── */}
      <PodcastBg />

      {/* blur layer 1 — top, gentle */}
      <div style={{ position: 'absolute', inset: 0, backdropFilter: 'blur(4px)', WebkitBackdropFilter: 'blur(4px)', background: 'rgba(8,19,38,.12)', maskImage: 'linear-gradient(to bottom, black 0%, transparent 55%)', WebkitMaskImage: 'linear-gradient(to bottom, black 0%, transparent 55%)' }} />
      {/* blur layer 2 — full, strong */}
      <div style={{ position: 'absolute', inset: 0, backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)', background: 'rgba(8,19,38,.45)', maskImage: 'linear-gradient(to top, black 0%, transparent 60%)', WebkitMaskImage: 'linear-gradient(to top, black 0%, transparent 60%)' }} />

      {/* ── modal ── */}
      <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px' }}>
        <div data-testid="rt-modal" className="rt-modal-inner" style={{ background: '#ffffff', borderRadius: 28, padding: '36px 40px', maxWidth: 560, width: '100%', boxShadow: '0 40px 100px rgba(8,19,38,.40), 0 8px 24px rgba(8,19,38,.18)', position: 'relative' }}>

          {/* X close button — top right */}
          <button
            data-testid="rt-close-btn"
            onClick={() => navigate(-1)}
            style={{
              position: 'absolute', top: 16, right: 18,
              width: 30, height: 30, borderRadius: '50%',
              background: '#F5F0E8', border: 'none',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'pointer', color: '#4A5D6E', fontSize: 16, lineHeight: 1,
              fontFamily: 'inherit',
            }}
            aria-label="Close"
          >✕</button>

          {/* branding row */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 24 }}>
            <div style={{ width: 36, height: 36, borderRadius: '50%', background: '#0D2137', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <span style={{ color: '#F5F0E8', fontSize: 10, fontWeight: 900, letterSpacing: '.05em' }}>OP</span>
            </div>
            <span style={{ fontSize: 13, fontWeight: 700, color: '#0D2137' }}>Opportunity Post</span>
            <span style={{ color: '#ccc', fontSize: 13 }}>·</span>
            <span style={{ fontSize: 13, fontWeight: 700, color: '#1B6B72' }}>Original Series</span>
          </div>

          {/* title */}
          <div style={{ marginBottom: 14 }}>
            <span className="rt-title" style={{ fontFamily: "'Inter Tight', sans-serif", fontWeight: 900, fontSize: 'clamp(1.7rem,4vw,2.8rem)', color: '#0D2137', lineHeight: 1.1 }}>Round Table </span>
            <span className="rt-title" style={{ fontFamily: "'Libre Baskerville', Georgia, serif", fontStyle: 'italic', fontWeight: 400, fontSize: 'clamp(1.7rem,4vw,2.8rem)', color: '#1B6B72', lineHeight: 1.1 }}>Podcast</span>
          </div>

          {/* subtitle */}
          <p className="rt-subtitle" style={{ fontSize: 14, color: '#4A5D6E', lineHeight: 1.7, textAlign: 'center', marginBottom: 28 }}>
            A weekly series featuring executives, educators, policymakers, and innovators exploring the ideas, opportunities, and innovations shaping work, education, and leadership in America.
          </p>

          {/* CTA button */}
          <Link
            to="/subscribe?product=round_table"
            data-testid="rt-subscribe-cta"
            style={{
              display: 'block', width: '100%', padding: '14px 20px',
              borderRadius: 10, background: '#0D2137', color: '#F5F0E8',
              fontWeight: 900, fontSize: 13, letterSpacing: '.1em',
              textTransform: 'uppercase', border: 'none', cursor: 'pointer',
              fontFamily: 'inherit', textDecoration: 'none', textAlign: 'center',
              boxSizing: 'border-box',
            }}
          >
            Stay Notified When We Launch →
          </Link>

          <div style={{ textAlign: 'center', marginTop: 12 }}>
            <p style={{ fontSize: 12, color: '#8A9BA8', lineHeight: 1.65, margin: '0 0 3px' }}>
              Subscribers get the launch date, featured guests and weekly drops
            </p>
            <p style={{ fontSize: 11, color: '#BBC4CC', lineHeight: 1.6, margin: 0 }}>
              before anyone else.
            </p>
          </div>

          <hr style={{ border: 'none', borderTop: '1px solid #EDE8D8', margin: '18px 0 14px' }} />

          {/* Returns Fall 2026 badge */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7, marginBottom: 12 }}>
            <div style={{ width: 7, height: 7, borderRadius: '50%', background: '#1B6B72' }} />
            <span style={{ fontSize: 11, fontWeight: 900, letterSpacing: '.12em', textTransform: 'uppercase', color: '#1B6B72' }}>Returns Fall 2026</span>
          </div>

          <p style={{ fontSize: 13, color: '#8A9BA8', textAlign: 'center', margin: 0, lineHeight: 1.7 }}>
            Presented by <strong style={{ color: '#0D2137' }}>Opportunity Post</strong> — Where opportunity begins.
          </p>

        </div>
      </div>

      <style>{`
        @media (max-width: 480px) {
          .rt-modal-inner { padding: 22px 18px !important; border-radius: 18px !important; }
          .rt-title { font-size: clamp(1.5rem, 8vw, 1.9rem) !important; }
          .rt-subtitle { font-size: 13px !important; margin-bottom: 16px !important; }
        }
      `}</style>
    </div>
  );
}
